import { confirmable } from 'react-confirm';
import { useTranslation } from 'react-i18next';
import StackedModal from './stacked_modal';

function CompleteDialog({ show, proceed, title, content, buttonText }) {
  const { t } = useTranslation('common');
  return (
    <StackedModal
      isOpen={show}
      title={title || t('common:button.confirm')}
      content={content || t('common:confirmation.confirm')}
      primaryAction={{
        content: buttonText || t('common:button.complete'),
        onAction: () => {
          proceed(true);
        },
      }}
      onClose={() => {
        proceed(false);
      }}
    />
  );
}

export default confirmable(CompleteDialog);
